import React from "react";

export default function WhyWeAre() {
  return (
    <div className="py-8 sm:py-12 md:py-16 lg:py-20 xl:py-[8.75rem]">
      <div className="px-4 sm:px-6 md:px-8 lg:px-10 ">
        {/* Header */}
        <div className="mb-8 sm:mb-10 md:mb-20 text-center max-w-[95rem] mx-auto ">
          <span  data-aos="fade-up" className="font-Matter font-semibold uppercase tracking-[.2em] text-white text-xl  md:text-6xl">
            Why are we the Best Diagnostic Center
          </span>
        </div>

        {/* List Items */}
        <ul className="space-y-6 sm:space-y-8 md:space-y-10 max-w-7xl mx-auto">
          {[
            {
              title: "Decades of Expertise",
              color: "text-[#cfa751]",
              description:
                "Serving since 1985 with high-quality imaging for patients’ wellness.",
            },
            {
              title: "Driven by Radiologists",
              color: "text-[#cfa751]",
              description:
                "Our experienced Radiologists are directly involved in providing the best patient care.",
            },
            {
              title: "ACR Accredited",
              color: "text-[#cfa751]",
              description:
                "Accredited by the American College of Radiology for top facilities and maintaining the standard quality.",
            },
            {
              title: "Board Certified Radiologists",
              color: "text-[#cfa751]",
              description:
                "Studies interpreted and analysed by a Board Certified Radiologist.",
            },
            {
              title: "Equipped with Registered Technologies",
              color: "text-[#cfa751]",
              description:
                "Imaging is carried out by advanced and registered technologies.",
            },
            {
              title: "Quick Results",
              color: "text-[#cfa751]",
              description:
                "Our team is committed to delivering your results within a rapid timeframe of 24 to 48 hours, ensuring efficiency without compromising quality.",
            },
            {
              title: "Affordable Services",
              color: "text-[#cfa751]",
              description:
                "Lower exam costs with less waiting time to ensure the patient’s comfort.",
            },
            {
              title: "STAT exams",
              color: "text-[#cfa751]",
              description:
                "Depending on the urgency, we provide STAT exam services.",
            },
          ].map((item, index) => (
            <li
              key={index}
              className="flex flex-col md:flex-row md:items-start md:justify-between border-b border-white border-opacity-15 py-6 md:py-8"
            >
              <span data-aos="fade-right" data-aos-delay={`${index+1 * 100}`}
                className={`font-Matter md:w-2/5 w-full  font-semibold ${item.color} text-3xl md:text-4xl lg:text-[2.5rem] leading-tight  mb-4 md:mb-0 md:max-w-[20rem]`}
              >
                {item.title}
              </span>
              <span  data-aos="fade-left" data-aos-delay={`${index+1 * 100}`} className="font-Matter md:w-3/5 w-full text-white text-xl  md:text-xl lg:text-[1.5rem] leading-relaxed md:max-w-[31.35rem]">
                {item.description}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
